<script setup lang="ts">
const question = [
  {
    title: '购买后是否可以开具发票？',
    content: '购买会员后，可以联系 Gloda客服开票，可提供电子发票。',
  },
  {
    title: '购买后是否可以退款？',
    content: '会员购买成功后立即生效，购买前请仔细核对确认购买信息，购买成功后视为主动、自愿购买，不支持退款。',
  },
  {
    title: '是否支持多设备登录？',
    content: '同一账号支持多端同时登录（PC+小程序），但每个端口仅支持一台设备同时在线。',
  },
  {
    title: '是否对公转账？',
    content: '对公充值用户需要先联系Gloda客服提供付款凭证（电子回单）及开通账号，客服处理账号升级并告知后，可向客服申请开票。',
  },
]
const { locale } = useI18n()
</script>

<template>
  <div class="g-user__question relative mx-auto mt-40 box-border w-1170 flex flex-col items-center gap-46 rd-16 px-118 py-60 pb-180">
    <div class="text-center text-36 text-[--color-text-1]">
      {{ $t('常见问题') }}
      <div mt-8 text-16>
        Q&A
      </div>
    </div>
    <div flex flex-wrap gap-x-96 gap-y-40>
      <div v-for="(item, index) in question" :key="item.title" class="w-416 flex gap-20">
        <div class="g-user__question--number h-31 w-31 flex items-center justify-center rd-8 rd-br-0 text-18 text-white font-dinpro600">
          Q{{ index + 1 }}
        </div>
        <div class="flex flex-1 flex-col gap-8">
          <div class="text-24 text-[--color-text-1]">
            {{ $t(item.title) }}
          </div>
          <div class="text-14 text-[--color-text-3] lh-22">
            {{ $t(item.content) }}
          </div>
        </div>
      </div>
    </div>
    <!-- <a-button class="g-user__question--btn group absolute left-50% top-[calc(100%-120px)] mt-8 min-w-208 rd-32 text-24 font-500 transition-[height,width,padding]-300 !h-54 -translate-x-1/2 hover:rd-16 hover:px-0 !text-white hover:!h-242" :class="{ 'px-40 ': locale === 'en' }">
      <span group-hover:hidden>{{ $t('更多问题咨询') }}</span>
      <div class="hidden w-full flex-col items-center gap-4 text-20 font-500 group-hover:flex">
        <span class="w-208 whitespace-pre-wrap">{{ $t('扫码咨询客服') }}</span>
        <img src="~/assets/images/user/vip/code.png" w-184 rd-8>
      </div>
    </a-button> -->
    <a-trigger position="top" auto-fit-position :unmount-on-close="false" :popup-translate="[0, -4]">
      <a-button class="g-user__question--btn group absolute left-50% top-[calc(100%-130px)] mt-8 min-w-208 rd-32 text-24 font-500 !h-54 -translate-x-1/2 !text-white" :class="{ 'px-40 ': locale === 'en' }">
        <span>{{ $t('更多问题咨询') }}</span>
      </a-button>
      <template #content>
        <div class="g-user__question--btn box-border w-208 flex flex-col items-center gap-6 rd-16 p-12 text-white">
          <span class="whitespace-pre-wrap text-center text-20 font-500 lh-32">{{ $t('扫码咨询客服') }}</span>
          <img src="~/assets/images/user/vip/code.png" w-184 rd-8>
        </div>
      </template>
    </a-trigger>
  </div>
</template>

<style lang="less" scoped>
.g-user__question{
  border-radius: 16px;
  background: linear-gradient(180deg, #EBE8FF 9.98%, #FFF 53.4%);
  &--number {
    background: linear-gradient(108deg, #924EF9 11.97%, #671BF8 85.26%);
  }
  &--btn {
    background: linear-gradient(100deg, #914DFA 17.49%, #681CF9 91.26%);
  }
}
</style>
